import { db } from "@/plugins/firebase";
import { IBanner } from "@/types/banner";
import { collection, query, where, getDocs, DocumentData } from "firebase/firestore";

export const getActiveBannersForCast = async (): Promise<IBanner[]> => {
    
    const q = query(collection(db, "mullion/v1/banners"), where('isDeleted', '==', false), where('isTargetCast', '==', true))
    const snapshot = await getDocs(q);
    const activeBanners: DocumentData[] = []
    snapshot.forEach((doc) => {
        const data = doc.data();
        const banner:IBanner = {
            bannerId: doc.id,
            imgSrc: data.imgSrc,
            href: data.href,
            bannerTitle: data.bannerTitle,
            isDeleted: data.isDeleted
        }
        activeBanners.push(banner);
    })
    
    return activeBanners as IBanner[];
}

export const getActiveBannersForGuest = async (): Promise<IBanner[]> => {
    
    const q = query(collection(db, "mullion/v1/banners"), where('isDeleted', '==', false), where('isTargetGuest', '==', true))
    const snapshot = await getDocs(q);
    const activeBanners: DocumentData[] = []
    snapshot.forEach((doc) => {
        const data = doc.data();
        const banner:IBanner = {
            bannerId: doc.id,
            imgSrc: data.imgSrc,
            href: data.href,
            bannerTitle: data.bannerTitle,
            isDeleted: data.isDeleted
        }
        activeBanners.push(banner);
    })
    
    return activeBanners as IBanner[];
}